/**
 * Parse a JSON string into a ProseMirror doc descriptor and ensure the content
 * array always has at least one block node. An empty content array is invalid
 * per the schema (`doc: { content: 'block+' }`) and causes list commands like
 * `wrapInList` to silently fail because there is no block to wrap.
 */
export function parseDocValue(value = '{}') {
  let parsedDoc;
  try {
    parsedDoc = JSON.parse(value);
  } catch (e) {
    parsedDoc = {};
  }
  if (!Array.isArray(parsedDoc.content)) {
    parsedDoc.content = [{ type: 'paragraph' }];
  }
  return parsedDoc;
}
